import React from "react";
import ReactExport from "react-export-excel";
import { FileExcelOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

function AnaliseExcell({ dados, ...props }) {
  return (
    <ExcelFile
      element={
        <Tooltip title="Exportar para Excell">
          <FileExcelOutlined className="icon-styled" style={{ fontSize: 30 }} />
        </Tooltip>
      }
    >
      <ExcelSheet data={dados} name="Analise">
        <ExcelColumn label="FABRICANTE" value="fabricante" />
        <ExcelColumn label="EAN" value="ean" />
        <ExcelColumn label="CÓDIGO" value="codigo" />
        <ExcelColumn label="UN" value="un" />
        <ExcelColumn label="NOME" value="nome" />
        <ExcelColumn label="SETOR" value="setor" />
        <ExcelColumn label="GRUPO" value="grupo" />
        <ExcelColumn label="EMBALAGEM" value="embalagem" />
        <ExcelColumn label="VALOR" value="valor" />
        <ExcelColumn label="CMV" value="cmv" />
        <ExcelColumn label="QTD" value="qtd" />
        <ExcelColumn label="ESTOQUE" value="estoque" />
        <ExcelColumn label="ESTOQUE MIN" value="estoqueMin" />
        <ExcelColumn label="ESTOQUE MAX" value="estoqueMax" />
        <ExcelColumn label="GIRO" value="giro" />
      </ExcelSheet>
    </ExcelFile>
  );
}

export default AnaliseExcell;
